import { render, staticRenderFns } from "./OperationsIcon.vue?vue&type=template&id=fa57e2ae"
import script from "./OperationsIcon.vue?vue&type=script&lang=js"
export * from "./OperationsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports